import { EVENT_TYPES } from '@care-portals/api-interfaces';

export const EVENT_TYPES_LIST = Object.entries(EVENT_TYPES).map(
  ([key, value]) => ({
    key,
    value,
    label: value
  })
);
